module.exports = __webpack_public_path__ + "static/media/upArrowIconLight.a5012852.svg";